import { render, staticRenderFns } from "./online-therapy.html?vue&type=template&id=14e16f68&scoped=true&external"
import script from "./online-therapy.js?vue&type=script&lang=js&external"
export * from "./online-therapy.js?vue&type=script&lang=js&external"
import style0 from "./online-therapy.scss?vue&type=style&index=0&id=14e16f68&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e16f68",
  null
  
)

export default component.exports